import * as msal from "@azure/msal-browser";
import { getEnv } from "../AppConfigs";
const msalConfig = {
  auth: {
    clientId: getEnv("REACT_APP_AZURE_AUTH_CLIENT_ID"),
    redirectUri: "/",
    authority: getEnv("REACT_APP_AZURE_AUTH_AUTHORITY"),
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export { msalInstance };
